import { __assign, __awaiter, __generator } from "tslib";
import videojs from "video.js";
import backwardSkip from "../../assets/icons/icon-backward-skip.svg";
import forwardSkip from "../../assets/icons/icon-forward-skip.svg";
import { videoOptions } from "../../config";
var SKIP_INTERVAL = 10;
export var delay = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
export var generateFakeId = function () {
    var text = "";
    var possible = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};
export function generateSequence(start, end) {
    var i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                i = start;
                _a.label = 1;
            case 1:
                if (!(i <= end)) return [3, 4];
                return [4, i];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3, 1];
            case 4: return [2];
        }
    });
}
export function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}
var toBase64 = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = function (error) { return reject(error); };
    });
};
function dataUrlToFile(dataUrl, fileName) {
    return __awaiter(this, void 0, void 0, function () {
        var res, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch(dataUrl)];
                case 1:
                    res = _a.sent();
                    return [4, res.blob()];
                case 2:
                    blob = _a.sent();
                    return [2, new File([blob], fileName, { type: "image/png" })];
            }
        });
    });
}
var downloadURI = function (url, filename) {
    fetch(url)
        .then(function (response) { return response.blob(); })
        .then(function (blob) {
        var csvBlob = new Blob([blob], { type: "text/csv" });
        var link = document.createElement("a");
        link.href = URL.createObjectURL(csvBlob);
        link.download = filename;
        link.click();
    })
        .catch(console.error);
};
var downloadExternalFile = function (url) {
    var link = document.createElement("a");
    link.target = "_blank";
    link.href = url;
    link.click();
};
export function getSelectOptions(arr, val1, val2) {
    return arr === null || arr === void 0 ? void 0 : arr.map(function (item) { return ({ value: item[val1], text: item[val2] }); });
}
export function getVideoPlayer(ref, url, additionalOptions) {
    var _a, _b;
    var videoPlayer = videojs(ref, __assign(__assign({}, videoOptions), (additionalOptions || {})));
    videoPlayer.src([
        {
            src: url,
            type: "application/x-mpegURL"
        }
    ]);
    var backwardBtnCollection = document.getElementsByClassName("vjs-backward-button");
    if (backwardBtnCollection.length === 0) {
        (_a = videoPlayer.getChild("ControlBar")) === null || _a === void 0 ? void 0 : _a.addChild("button", {
            controlText: "backward",
            className: "vjs-backward-button",
            clickHandler: function () {
                videoPlayer.currentTime(videoPlayer.currentTime() - SKIP_INTERVAL);
            }
        }, 1);
        backwardBtnCollection[0].innerHTML = "<img src=\"".concat(backwardSkip, "\">");
        backwardBtnCollection[0].style.cursor = "pointer";
    }
    var forwardBtnCollection = document.getElementsByClassName("vjs-forward-button");
    if (forwardBtnCollection.length === 0) {
        (_b = videoPlayer.getChild("ControlBar")) === null || _b === void 0 ? void 0 : _b.addChild("button", {
            controlText: "forward",
            className: "vjs-forward-button",
            clickHandler: function () {
                videoPlayer.currentTime(videoPlayer.currentTime() + SKIP_INTERVAL);
            }
        }, 2);
        forwardBtnCollection[0].innerHTML = "<img src=\"".concat(forwardSkip, "\">");
        forwardBtnCollection[0].style.cursor = "pointer";
    }
    return videoPlayer;
}
export var getSanitizedHtmlText = function (text) {
    return (text === null || text === void 0 ? void 0 : text.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ")) || "";
};
export { toBase64, dataUrlToFile, downloadURI, downloadExternalFile };
//# sourceMappingURL=helpers.js.map